module.exports = __webpack_public_path__ + "img/29passenger_stopped.17d6e6ce.svg";